export default "__VITE_ASSET__aikv$Cwg__"